/* numbuzin — interacciones propias (vanilla, sin librerías) */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mt-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  function initCountUp() {
    var nums = document.querySelectorAll('[data-count]');
    if (!nums.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      nums.forEach(function (n) { n.textContent = n.getAttribute('data-count'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        obs.unobserve(el);
        var target = parseFloat(el.getAttribute('data-count'));
        var decimals = (el.getAttribute('data-count').split('.')[1] || '').length;
        var dur = 1500, start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = (target * eased).toFixed(decimals);
          if (p < 1) requestAnimationFrame(step);
          else el.textContent = target.toFixed(decimals);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { obs.observe(n); });
  }

  function initFaq() {
    var items = document.querySelectorAll('.mt-faq__item');
    if (!items.length) return;
    items.forEach(function (item) {
      var q = item.querySelector('.mt-faq__q');
      var a = item.querySelector('.mt-faq__a');
      if (!q || !a) return;
      q.addEventListener('click', function () {
        var open = item.classList.contains('mt-open');
        item.classList.toggle('mt-open');
        a.style.maxHeight = open ? null : a.scrollHeight + 'px';
      });
    });
  }

  function initGallery() {
    var gallery = document.querySelector('.mt-pd__gallery');
    if (!gallery) return;
    var main = gallery.querySelector('.mt-pd__main img');
    var mainBox = gallery.querySelector('[data-gal-main]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.mt-pd__thumb'));
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-gal-dot]'));
    var curEl = gallery.querySelector('[data-gal-cur]');
    if (!main || !thumbs.length) return;

    // Lista de fotos a partir de las miniaturas (fuente de verdad del carrusel)
    var slides = thumbs.map(function (t) { return t.getAttribute('data-full'); });
    var current = 0;

    function show(i, focusThumb) {
      current = (i + slides.length) % slides.length;
      if (slides[current]) {
        main.classList.add('mt-swapping');
        main.src = slides[current];
      }
      thumbs.forEach(function (x, k) { x.classList.toggle('mt-active', k === current); });
      dots.forEach(function (d, k) { d.classList.toggle('mt-active', k === current); });
      if (curEl) curEl.textContent = current + 1;
      if (gallery._mtCf) gallery._mtCf(current);
      if (focusThumb && thumbs[current] && thumbs[current].scrollIntoView) {
        thumbs[current].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      }
    }

    main.addEventListener('load', function () { main.classList.remove('mt-swapping'); });

    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { show(i, true); }); });

    var prev = gallery.querySelector('[data-gal-prev]');
    var next = gallery.querySelector('[data-gal-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1, true); });
    if (next) next.addEventListener('click', function () { show(current + 1, true); });

    // Deslizar con el dedo (carrusel en móvil)
    if (mainBox) {
      var x0 = null;
      mainBox.addEventListener('touchstart', function (e) { x0 = e.changedTouches[0].clientX; }, { passive: true });
      mainBox.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) { show(dx < 0 ? current + 1 : current - 1, true); }
      }, { passive: true });
    }

    // Flechas del teclado cuando el ratón está sobre la galería
    gallery.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { show(current - 1, true); }
      else if (e.key === 'ArrowRight') { show(current + 1, true); }
    });

    // Permite a otras funciones (cambio de color) resincronizar el estado
    gallery._mtGalShow = show;
    gallery._mtGalIndex = function () { return current; };
  }

  // Humo: una sola bocanada en el pack que se pulsa
  function initHumo() {
    document.querySelectorAll('.mt-pd__pack').forEach(function (p) {
      if (!p.querySelector('.mt-pd__humo')) return;
      var t = null;
      p.addEventListener('click', function () {
        p.classList.remove('mt-humo-on');
        void p.offsetWidth; // reinicia la animación si se pulsa otra vez
        p.classList.add('mt-humo-on');
        clearTimeout(t);
        t = setTimeout(function () { p.classList.remove('mt-humo-on'); }, 3400);
      });
    });
  }

  // Carrusel 3D de fotos (la del centro grande, las de los lados más pequeñas e inclinadas)
  function initCoverflow() {
    var gallery = document.querySelector('.mt-pd__gallery');
    var cf = gallery && gallery.querySelector('[data-mt-cf]');
    if (!cf || !gallery._mtGalShow) return;
    var cards = Array.prototype.slice.call(cf.querySelectorAll('.mt-cf__card'));
    var n = cards.length;
    if (n < 2) return;

    function place(cur) {
      cards.forEach(function (c, i) {
        var off = i - cur;
        if (off > n / 2) off -= n;
        if (off < -n / 2) off += n;
        c.setAttribute('data-off', Math.max(-2, Math.min(2, off)));
        c.setAttribute('aria-hidden', off === 0 ? 'false' : 'true');
      });
    }
    gallery._mtCf = place;
    place(gallery._mtGalIndex());

    var timer = null;
    var secs = parseFloat(cf.getAttribute('data-auto')) || 0;
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      if (reduce || !secs || timer) return;
      timer = setInterval(function () { gallery._mtGalShow(gallery._mtGalIndex() + 1); }, secs * 1000);
    }

    cards.forEach(function (c, i) {
      c.addEventListener('click', function () {
        if (c.getAttribute('data-off') !== '0') { stop(); gallery._mtGalShow(i); }
      });
    });
    var prev = cf.querySelector('[data-cf-prev]');
    var next = cf.querySelector('[data-cf-next]');
    if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); stop(); gallery._mtGalShow(gallery._mtGalIndex() - 1); });
    if (next) next.addEventListener('click', function (e) { e.stopPropagation(); stop(); gallery._mtGalShow(gallery._mtGalIndex() + 1); });

    // Pasa solo; se detiene en cuanto la clienta toca el carrusel
    var stopped = false;
    function stopForGood() { stopped = true; stop(); }
    gallery.addEventListener('pointerdown', stopForGood);
    gallery.addEventListener('touchstart', stopForGood, { passive: true });
    cf.addEventListener('mouseenter', stop);
    cf.addEventListener('mouseleave', function () { if (!stopped) start(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting && !stopped) start(); else stop(); });
      }).observe(cf);
    } else { start(); }
  }

  function initVariants() {
    var root = document.querySelector('[data-mt-product]');
    if (!root) return;
    var dataEl = root.querySelector('[data-mt-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = root.querySelector('input[name="id"]');
    var priceNow = root.querySelector('.mt-pd__price-now');
    var priceOld = root.querySelector('.mt-pd__price-old');
    var addBtn = root.querySelector('.mt-pd__form-btn');
    var addLabel = addBtn ? addBtn.getAttribute('data-label-add') : '';
    var soldLabel = addBtn ? addBtn.getAttribute('data-label-sold') : '';
    var optBtns = root.querySelectorAll('.mt-pd__opt-btn');
    var selected = {};

    function fmt(cents) {
      return '€' + (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    function match() {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return selected[i] === opt; });
      });
    }
    function apply() {
      var v = match();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceNow) priceNow.textContent = fmt(v.price);
      if (priceOld) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceOld.textContent = fmt(v.compare_at_price);
          priceOld.style.display = '';
        } else { priceOld.style.display = 'none'; }
      }
      if (addBtn) {
        if (v.available) { addBtn.disabled = false; addBtn.textContent = addLabel; }
        else { addBtn.disabled = true; addBtn.textContent = soldLabel; }
      }
    }
    optBtns.forEach(function (btn) {
      var idx = parseInt(btn.getAttribute('data-opt-index'), 10);
      if (selected[idx] === undefined) selected[idx] = btn.getAttribute('data-opt-value');
      btn.addEventListener('click', function () {
        selected[idx] = btn.getAttribute('data-opt-value');
        root.querySelectorAll('.mt-pd__opt-btn[data-opt-index="' + idx + '"]').forEach(function (b) {
          b.classList.remove('mt-active');
        });
        btn.classList.add('mt-active');
        apply();
      });
    });
    apply();
  }

  function initPackColors() {
    var root = document.querySelector('[data-mt-product]');
    if (!root) return;
    var box = root.querySelector('[data-mt-colors]');
    if (!box) return;
    var rows = box.querySelectorAll('.mt-pd__color-row');
    var modal = document.querySelector('[data-colormodal]');
    var summaryEl = root.querySelector('[data-color-summary]');
    function openModal() { if (!modal) return; modal.hidden = false; requestAnimationFrame(function () { modal.classList.add('mt-open'); }); document.documentElement.classList.add('mt-modal-lock'); }
    function closeModal() { if (!modal) return; modal.classList.remove('mt-open'); document.documentElement.classList.remove('mt-modal-lock'); setTimeout(function () { modal.hidden = true; }, 300); updateSummary(); }
    function updateSummary() {
      if (!summaryEl) return;
      var qty = currentQty(), vals = [];
      rows.forEach(function (row, i) { if (i < qty) { var inp = row.querySelector('[data-color-input]'); if (inp) vals.push(inp.value); } });
      summaryEl.textContent = vals.length ? vals.join(' · ') : 'Toca para elegir';
    }
    if (modal) modal.querySelectorAll('[data-colormodal-close]').forEach(function (b) { b.addEventListener('click', closeModal); });
    var opener = root.querySelector('[data-colormodal-open]');
    if (opener) opener.addEventListener('click', openModal);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && !modal.hidden) closeModal(); });

    function currentQty() {
      var active = root.querySelector('.mt-pd__pack.mt-active[data-opt-index="0"]') || root.querySelector('.mt-pd__pack.mt-active');
      var q = active ? parseInt(active.getAttribute('data-opt-value'), 10) : 1;
      return isNaN(q) ? 1 : q;
    }
    function updateRows() {
      var qty = currentQty();
      rows.forEach(function (row, i) {
        var n = i + 1;
        var input = row.querySelector('[data-color-input]');
        var ulabel = row.querySelector('.mt-pd__color-ulabel');
        if (n <= qty) {
          row.hidden = false;
          if (input) input.disabled = false;
          if (ulabel) ulabel.textContent = qty === 1 ? 'Color' : ('Unidad ' + n);
        } else {
          row.hidden = true;
          if (input) input.disabled = true;
        }
      });
    }
    box.querySelectorAll('.mt-pd__color-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = btn.getAttribute('data-color-val');
        var row = btn.closest('.mt-pd__color-row');
        if (!row) return;
        row.querySelectorAll('.mt-pd__color-btn').forEach(function (b) { b.classList.remove('mt-active'); });
        btn.classList.add('mt-active');
        var input = row.querySelector('[data-color-input]');
        if (input) input.value = val;
        updateSummary();
        var swap = btn.getAttribute('data-swap-img');
        var mainImg = root.querySelector('.mt-pd__main img');
        if (swap && mainImg) {
          mainImg.src = swap;
          var activeThumb = root.querySelector('.mt-pd__thumb.mt-active');
          if (activeThumb) activeThumb.classList.remove('mt-active');
          var activeDot = root.querySelector('.mt-pd__dot.mt-active');
          if (activeDot) activeDot.classList.remove('mt-active');
        }
      });
    });
    root.querySelectorAll('.mt-pd__pack[data-opt-index="0"]').forEach(function (b) {
      b.addEventListener('click', function () { setTimeout(function () { updateRows(); updateSummary(); openModal(); }, 0); });
    });
    updateRows();
    updateSummary();
  }

  function initReels() {
    // Vídeos de la ficha (reels y fila de TikToks): solo se descargan y se reproducen mientras se ven
    var vids = document.querySelectorAll('.mt-reel__video, .mt-tk__video');
    if (!vids.length) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.play().catch(function () {}); }
          else { e.target.pause(); }
        });
      }, { threshold: 0.35 });
      vids.forEach(function (v) { io.observe(v); });
    } else {
      vids.forEach(function (v) { v.play().catch(function () {}); });
    }
    document.querySelectorAll('[data-mt-reel-sound]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var frame = btn.closest('.mt-reel__frame');
        var v = frame ? frame.querySelector('video') : null;
        if (!v) return;
        if (v.muted) {
          document.querySelectorAll('.mt-reel__video').forEach(function (o) { o.muted = true; });
          document.querySelectorAll('[data-mt-reel-sound]').forEach(function (b) { b.textContent = '🔇'; });
          v.muted = false; btn.textContent = '🔊'; v.play().catch(function () {});
        } else {
          v.muted = true; btn.textContent = '🔇';
        }
      });
    });
  }

  function initStickyBar() {
    var bar = document.querySelector('[data-mt-stickybar]');
    if (!bar) return;
    var root = document.querySelector('[data-mt-product]');
    if (!root) return;
    var mainBtn = root.querySelector('.mt-pd__form-btn');
    if (!mainBtn) return;
    var mainPrice = root.querySelector('.mt-pd__price-now');
    var stickyBtn = bar.querySelector('[data-mt-sticky-add]');
    var stickyPrice = bar.querySelector('[data-mt-sticky-price]');

    // el botón de la barra dispara el MISMO formulario (la variante/pack ya está
    // sincronizada en el input hidden por initVariants)
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (mainBtn.disabled) return;
        mainBtn.click();
      });
    }

    // reflejar precio y disponibilidad del botón principal
    function sync() {
      if (stickyPrice && mainPrice) stickyPrice.textContent = mainPrice.textContent;
      if (stickyBtn) stickyBtn.disabled = !!mainBtn.disabled;
    }
    root.querySelectorAll('.mt-pd__opt-btn').forEach(function (b) {
      b.addEventListener('click', function () { setTimeout(sync, 0); });
    });
    sync();

    // mostrar solo cuando el botón principal ha quedado POR ENCIMA del viewport
    // (el usuario ha bajado más allá de él); ocultar cuando vuelve a estar a la vista
    function update() {
      var r = mainBtn.getBoundingClientRect();
      var past = r.bottom < 8;
      if (past) {
        if (bar.hidden) { bar.hidden = false; setTimeout(function () { bar.classList.add('mt-show'); }, 20); }
        else { bar.classList.add('mt-show'); }
      } else {
        bar.classList.remove('mt-show');
      }
    }
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      setTimeout(function () { update(); ticking = false; }, 80);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function initHero3D() {
    var hero = document.querySelector('[data-hero3d]');
    if (!hero || reduce) return;
    var tilt = hero.querySelector('[data-hero3d-tilt]');
    var depthEls = hero.querySelectorAll('[data-depth]');
    var hint = hero.querySelector('[data-spin-hint]');
    var touch = window.matchMedia && window.matchMedia('(hover: none)').matches;
    var rotY = 0, rotX = 0, targetY = 0, targetX = 0;
    var px = 0, py = 0, t = 0;
    var auto = true, dragging = false, lastX = 0, interacted = false;

    function markInteract() {
      if (!interacted && hint) { interacted = true; hint.classList.add('mt-hide'); }
    }
    if (!touch) {
      hero.addEventListener('mousemove', function (e) {
        var r = hero.getBoundingClientRect();
        px = (e.clientX - r.left) / r.width - 0.5;
        py = (e.clientY - r.top) / r.height - 0.5;
        if (!dragging) { targetY = px * 42; targetX = -py * 14; auto = false; }
      });
      hero.addEventListener('mouseleave', function () { auto = true; px = 0; py = 0; });
    }
    function clamp(v) { return Math.max(-85, Math.min(85, v)); }
    function down(e) { dragging = true; auto = false; markInteract(); lastX = (e.touches ? e.touches[0].clientX : e.clientX); hero.classList.add('mt-grabbing'); }
    function move(e) { if (!dragging) return; var x = (e.touches ? e.touches[0].clientX : e.clientX); targetY = clamp(targetY + (x - lastX) * 0.6); lastX = x; }
    function up() { if (dragging) { dragging = false; hero.classList.remove('mt-grabbing'); auto = true; } }
    if (tilt) {
      tilt.addEventListener('mousedown', down);
      tilt.addEventListener('touchstart', down, { passive: true });
    }
    window.addEventListener('mousemove', move);
    window.addEventListener('touchmove', move, { passive: true });
    window.addEventListener('mouseup', up);
    window.addEventListener('touchend', up);
    hero.addEventListener('mouseenter', markInteract);

    function loop() {
      t += 0.016;
      if (auto && !dragging) { targetY = Math.sin(t * 0.55) * 22; targetX = Math.sin(t * 0.4) * 4; }
      rotY += (targetY - rotY) * 0.08;
      rotX += (targetX - rotX) * 0.08;
      if (tilt) tilt.style.transform = 'rotateY(' + rotY.toFixed(2) + 'deg) rotateX(' + rotX.toFixed(2) + 'deg)';
      depthEls.forEach(function (el) {
        var d = parseFloat(el.getAttribute('data-depth')) || 0;
        el.style.translate = (px * d * 55) + 'px ' + (py * d * 55) + 'px';
      });
      requestAnimationFrame(loop);
    }
    requestAnimationFrame(loop);
  }

  function initCountdown() {
    var el = document.querySelector('[data-countdown]');
    if (!el) return;
    var out = el.querySelector('[data-countdown-time]');
    var hEl = el.querySelector('[data-cd-h]'), mEl = el.querySelector('[data-cd-m]'), sEl = el.querySelector('[data-cd-s]');
    if (!out && !hEl) return;
    var hours = parseFloat(el.getAttribute('data-countdown')) || 8;
    var key = 'mt_deadline_h' + Math.round(hours);
    var dl = 0;
    try { dl = parseInt(localStorage.getItem(key), 10) || 0; } catch (e) {}
    var now = Date.now();
    if (!dl || dl < now) { dl = now + hours * 3600 * 1000; try { localStorage.setItem(key, dl); } catch (e) {} }
    function two(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var s = Math.max(0, Math.floor((dl - Date.now()) / 1000));
      var hh = Math.floor(s / 3600), mm = Math.floor((s % 3600) / 60), ss = s % 60;
      if (out) out.textContent = two(hh) + ':' + two(mm) + ':' + two(ss);
      if (hEl) hEl.textContent = two(hh);
      if (mEl) mEl.textContent = two(mm);
      if (sEl) sEl.textContent = two(ss);
    }
    tick();
    setInterval(tick, 1000);
    var dv = el.querySelector('[data-cd-deliver]');
    if (dv) {
      var M = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
      var bd = function (n) { var x = new Date(now), c = 0; while (c < n) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0 && x.getDay() !== 6) c++; } return x; };
      var f = bd(5), t = bd(8);
      dv.textContent = (f.getMonth() === t.getMonth())
        ? 'y lo recibes entre el ' + f.getDate() + ' y el ' + t.getDate() + ' de ' + M[t.getMonth()]
        : 'y lo recibes entre el ' + f.getDate() + ' de ' + M[f.getMonth()] + ' y el ' + t.getDate() + ' de ' + M[t.getMonth()];
    }
  }

  function initTilt() {
    if (reduce) return;
    if (window.matchMedia && window.matchMedia('(hover: none)').matches) return;
    var els = document.querySelectorAll('[data-tilt]');
    els.forEach(function (el) {
      var raf = null, px = 0, py = 0;
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        px = (e.clientX - r.left) / r.width - 0.5;
        py = (e.clientY - r.top) / r.height - 0.5;
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          el.style.transform = 'perspective(700px) rotateY(' + (px * 12) + 'deg) rotateX(' + (-py * 12) + 'deg) translateY(-6px) scale(1.03)';
        });
      });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
  }

  function initLiveCount() {
    var el = document.querySelector('[data-live-count]');
    if (!el || reduce) return;
    var base = parseInt(el.textContent, 10) || 20;
    setInterval(function () {
      var delta = Math.floor(Math.random() * 7) - 3;
      var next = Math.max(8, base + delta);
      el.textContent = next;
    }, 3500);
  }

  function initUpsell() {
    var box = document.querySelector('[data-upsell]');
    if (!box) return;
    var options = [].slice.call(box.querySelectorAll('[data-upsell-option]'));
    if (!options.length) return;

    // elegir uno al azar entre los que NO están ya en la cesta
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inCart = function (o) {
          return cart.items.some(function (it) { return String(it.variant_id) === o.getAttribute('data-variant'); });
        };
        var avail = options.filter(function (o) { return !inCart(o); });
        if (!avail.length) return; // todos ya en la cesta -> no mostrar
        var chosen = avail[Math.floor(Math.random() * avail.length)];
        options.forEach(function (o) { if (o !== chosen) { o.parentNode.removeChild(o); } });
        chosen.hidden = false;
        box.hidden = false;
      })
      .catch(function () {
        // fallback: mostrar el primero
        options.forEach(function (o, i) { if (i > 0) o.parentNode.removeChild(o); });
        options[0].hidden = false;
        box.hidden = false;
      });

    // añadir (delegado, funciona sea cual sea la opción mostrada)
    box.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-upsell-add]');
      if (!btn) return;
      var id = btn.getAttribute('data-variant-id');
      var done = btn.getAttribute('data-label-done') || '✓';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(id), quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () { btn.textContent = done; setTimeout(function () { window.location.reload(); }, 500); })
        .catch(function () { btn.disabled = false; });
    });
  }

  function initRutina() {
    var box = document.querySelector('[data-rutina]');
    if (!box) return;
    var current = box.getAttribute('data-current-handle');
    var cards = [].slice.call(box.querySelectorAll('[data-rutina-card]'));
    var visible = 0;
    cards.forEach(function (c) {
      if (current && c.getAttribute('data-handle') === current) { c.parentNode.removeChild(c); }
      else visible++;
    });
    if (!visible) { box.hidden = true; return; }

    // añadir por AJAX sin salir de la página
    box.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rutina-add]');
      if (!btn || btn.disabled) return;
      var id = btn.getAttribute('data-variant-id');
      var done = btn.getAttribute('data-label-done') || '✓ Añadido';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(id), quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = done;
          btn.classList.add('mt-rutina__btn--done');
          setTimeout(function () { window.location.reload(); }, 800);
        })
        .catch(function () { btn.disabled = false; });
    });
  }

  function initWelcome() {
    var pop = document.querySelector('[data-welcome]');
    if (!pop) return;
    var path = window.location.pathname;
    if (/\/(cart|checkout|checkouts|orders|thank_you)/.test(path)) return;
    if (window.Shopify && window.Shopify.designMode) return;

    // tras enviar el email (bien o con error) la página se recarga: hay que volver a abrir el popup
    var success = !!pop.querySelector('[data-welcome-success], [data-welcome-error]');
    var shownKey = 'mt_welcome_shown';
    var opened = false;

    function open() {
      if (opened) return;
      opened = true;
      pop.hidden = false;
      requestAnimationFrame(function () { pop.classList.add('mt-open'); });
      try { localStorage.setItem(shownKey, '1'); } catch (e) {}
    }
    function close() {
      pop.classList.remove('mt-open');
      setTimeout(function () { pop.hidden = true; }, 400);
    }
    pop.querySelectorAll('[data-welcome-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });

    var copyBtn = pop.querySelector('[data-welcome-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = (pop.querySelector('[data-welcome-code]') || {}).textContent || '';
        var done = function () { copyBtn.textContent = '✓ Copiado'; };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code.trim()).then(done).catch(done);
        } else { done(); }
      });
    }

    if (success) { open(); return; } // acaba de suscribirse: mostrar el código

    var already;
    try { already = localStorage.getItem(shownKey) === '1'; } catch (e) { already = false; }
    if (already) return;

    var delay = parseInt(pop.getAttribute('data-delay'), 10);
    if (isNaN(delay)) delay = 6;
    if (delay >= 0) setTimeout(open, delay * 1000);
    // también al intentar salir (escritorio)
    document.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget && e.clientY <= 0) open();
    });
  }

  function initCartPopup() {
    var pop = document.querySelector('[data-cart-popup]');
    if (!pop) return;
    var path = window.location.pathname;
    if (/\/(cart|checkout|checkouts|orders|thank_you)/.test(path)) return;
    if (window.Shopify && window.Shopify.designMode) return;

    var once = pop.getAttribute('data-once') === 'true';
    var delay = parseInt(pop.getAttribute('data-delay'), 10);
    if (isNaN(delay)) delay = 30;
    var shownKey = 'mt_cartpop_shown';
    var shown = false, armed = false, closed = false;

    function money(cents) {
      return '€' + (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    function alreadyShown() {
      if (!once) return false;
      try { return sessionStorage.getItem(shownKey) === '1'; } catch (e) { return false; }
    }
    function open() {
      if (shown || closed || alreadyShown()) return;
      shown = true;
      try { if (once) sessionStorage.setItem(shownKey, '1'); } catch (e) {}
      pop.hidden = false;
      requestAnimationFrame(function () { pop.classList.add('mt-open'); });
    }
    function close() {
      closed = true;
      pop.classList.remove('mt-open');
      setTimeout(function () { pop.hidden = true; }, 400);
    }
    pop.querySelectorAll('[data-cartpop-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });

    function renderItem(cart) {
      var box = pop.querySelector('[data-cartpop-item]');
      if (!box) return;
      var it = cart.items[0];
      if (!it) { box.style.display = 'none'; return; }
      var img = it.image ? '<img src="' + it.image + '" alt="">' : '';
      var qtyLine = (cart.item_count > 1 ? cart.item_count + ' artículos' : (it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '1 unidad'));
      box.innerHTML = img +
        '<div class="mt-cartpop__item-info">' +
          '<span class="mt-cartpop__item-title">' + it.product_title + '</span>' +
          '<span class="mt-cartpop__item-meta">' + qtyLine + '</span>' +
        '</div>' +
        '<span class="mt-cartpop__item-price">' + money(cart.total_price) + '</span>';
    }

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || cart.item_count < 1) return;
        renderItem(cart);
        armed = true;
        // intención de salida (escritorio)
        document.addEventListener('mouseout', function (e) {
          if (!armed) return;
          if (!e.relatedTarget && e.clientY <= 0) open();
        });
        // fallback por tiempo (móvil / si no sale el ratón)
        if (delay > 0) setTimeout(function () { if (armed) open(); }, delay * 1000);
      })
      .catch(function () {});
  }

  function initVideoSound() {
    var video = document.querySelector('.mt-video__frame video');
    if (!video) return;
    // reproducir al entrar en pantalla, pausar al salir
    if ('IntersectionObserver' in window && !reduce) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { video.play().catch(function () {}); }
          else { video.pause(); }
        });
      }, { threshold: 0.35 });
      obs.observe(video);
    }
    var btn = document.querySelector('[data-video-sound]');
    if (btn) {
      btn.addEventListener('click', function () {
        video.muted = !video.muted;
        if (!video.muted) { video.play().catch(function () {}); }
        btn.textContent = video.muted ? '🔇' : '🔊';
      });
    }
  }

  function initSalePops() {
    var box = document.querySelector('[data-mt-salepop]');
    if (!box) return;
    var path = location.pathname || '';
    if (path.indexOf('/cart') === 0 || path.indexOf('/checkout') === 0) return;
    var people;
    try { people = JSON.parse(box.querySelector('[data-salepop-people]').textContent); } catch (e) { return; }
    if (!people || !people.length) return;
    var producto = box.getAttribute('data-producto') || 'el producto';
    var verbo = box.getAttribute('data-verbo') || 'acaba de comprar';
    var img = box.getAttribute('data-img') || '';
    var minS = parseInt(box.getAttribute('data-min'), 10) || 9;
    var maxS = parseInt(box.getAttribute('data-max'), 10) || 20;
    var firstS = parseInt(box.getAttribute('data-first'), 10) || 7;
    // barajar
    for (var k = people.length - 1; k > 0; k--) { var j = Math.floor(Math.random() * (k + 1)); var tmp = people[k]; people[k] = people[j]; people[j] = tmp; }
    var idx = 0, current = null, stopped = false;
    function rnd(a, b) { return a + Math.random() * (b - a); }
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }
    function hide() {
      if (!current) return;
      var c = current; current = null;
      c.classList.remove('mt-in');
      setTimeout(function () { if (c && c.parentNode) c.parentNode.removeChild(c); }, 550);
    }
    function show() {
      if (stopped) return;
      var p = people[idx % people.length]; idx++;
      var mins = Math.floor(rnd(2, 40));
      var loc = p.c ? (' de ' + esc(p.c)) : '';
      var el = document.createElement('div');
      el.className = 'mt-salepop__card';
      el.innerHTML =
        (img ? '<span class="mt-salepop__img" style="background-image:url(\'' + img + '\')"></span>' : '') +
        '<span class="mt-salepop__txt"><b>' + esc(p.n) + '</b>' + loc + ' ' + esc(verbo) + ' <b>' + esc(producto) + '</b>' +
        '<small>&#10003; Compra verificada &middot; hace ' + mins + ' min</small></span>' +
        '<button class="mt-salepop__x" type="button" aria-label="Cerrar">&times;</button>';
      box.appendChild(el);
      current = el;
      el.querySelector('.mt-salepop__x').addEventListener('click', function () { stopped = true; hide(); });
      requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('mt-in'); }); });
      setTimeout(hide, 5200);
      setTimeout(show, rnd(minS, maxS) * 1000 + 5200);
    }
    box.hidden = false;
    setTimeout(show, firstS * 1000);
  }

  function initAntesDespues() {
    document.querySelectorAll('[data-mt-ad]').forEach(function (ad) {
      var pos = 50, dragging = false;
      function set(p) { pos = Math.max(2, Math.min(98, p)); ad.style.setProperty('--pos', pos + '%'); }
      function fromEvent(e) {
        var r = ad.getBoundingClientRect();
        var cx = (e.touches && e.touches[0]) ? e.touches[0].clientX : e.clientX;
        set(((cx - r.left) / r.width) * 100);
      }
      ad.addEventListener('mousedown', function (e) { dragging = true; fromEvent(e); e.preventDefault(); });
      ad.addEventListener('touchstart', function (e) { dragging = true; fromEvent(e); }, { passive: true });
      window.addEventListener('mousemove', function (e) { if (dragging) fromEvent(e); });
      window.addEventListener('touchmove', function (e) { if (dragging) fromEvent(e); }, { passive: true });
      window.addEventListener('mouseup', function () { dragging = false; });
      window.addEventListener('touchend', function () { dragging = false; });
      // pequeño vaivén inicial para invitar a interactuar
      if (!reduce) {
        var hinted = false;
        var io = new IntersectionObserver(function (ents) {
          ents.forEach(function (en) {
            if (en.isIntersecting && !hinted) {
              hinted = true;
              ad.style.transition = 'none';
              var seq = [50, 66, 38, 50], k = 0;
              var iv = setInterval(function () { set(seq[k]); k++; if (k >= seq.length) clearInterval(iv); }, 420);
            }
          });
        }, { threshold: 0.4 });
        io.observe(ad);
      }
      set(50);
    });
  }

  function initGifts() {
    var root = document.querySelector('[data-mt-product]');
    if (!root) return;
    var box = root.querySelector('[data-mt-gifts]');
    if (!box) return;
    var stateEl = box.querySelector('[data-gifts-state]');
    var hintEl = box.querySelector('[data-gifts-hint]');
    var prop = box.querySelector('[data-gifts-prop]');
    var wasUnlocked = false, inited = false;
    function currentQty() {
      var a = root.querySelector('.mt-pd__pack.mt-active[data-opt-index="0"]') || root.querySelector('.mt-pd__pack.mt-active');
      var q = a ? parseInt(a.getAttribute('data-opt-value'), 10) : 1;
      return isNaN(q) ? 1 : q;
    }
    function update(animate) {
      var q = currentQty();
      var unlocked = q >= 2;
      box.classList.toggle('mt-unlocked', unlocked);
      if (prop) {
        prop.disabled = !unlocked;
        var val = q >= 3 ? prop.getAttribute('data-val3') : prop.getAttribute('data-val2');
        if (val) prop.value = val;
      }
      if (stateEl) stateEl.textContent = unlocked ? '🔓 ¡Regalos desbloqueados!' : '🔒 Regalos bloqueados';
      if (hintEl) hintEl.textContent = unlocked ? 'Pack de 3 raspadores + hilo dental incluidos GRATIS' : 'Elige el pack de 2 (o 3) y desbloquea 2 regalos GRATIS';
      if (animate && inited && unlocked && !wasUnlocked && !reduce) {
        box.classList.remove('mt-burst'); void box.offsetWidth; box.classList.add('mt-burst');
        setTimeout(function () { box.classList.remove('mt-burst'); }, 1100);
      }
      wasUnlocked = unlocked;
    }
    root.querySelectorAll('.mt-pd__pack[data-opt-index="0"]').forEach(function (b) {
      b.addEventListener('click', function () { setTimeout(function () { update(true); }, 0); });
    });
    update(false);
    inited = true;
  }

  function initDrawer() {
    var drawer = document.querySelector('[data-mt-drawer]');
    if (!drawer) return;
    var panel = drawer.querySelector('.mt-drawer__panel');
    var itemsEl = drawer.querySelector('[data-drawer-items]');
    var emptyEl = drawer.querySelector('[data-drawer-empty]');
    var footEl = drawer.querySelector('[data-drawer-foot]');
    var subEl = drawer.querySelector('[data-drawer-subtotal]');
    var countEl = drawer.querySelector('[data-drawer-count]');
    var giftEl = drawer.querySelector('[data-drawer-gift]');
    var giftTxt = drawer.querySelector('[data-gift-txt]');
    var giftFill = drawer.querySelector('[data-gift-fill]');
    var upsellEl = drawer.querySelector('[data-drawer-upsell]');
    var v1 = drawer.getAttribute('data-v1');
    var v2 = drawer.getAttribute('data-v2');
    var giftsOn = drawer.getAttribute('data-gifts') === 'on';
    var giftNames = drawer.getAttribute('data-gift-names') || '';
    var upsellTxt = drawer.getAttribute('data-upsell-txt') || '';
    var upsellBtn = drawer.getAttribute('data-upsell-btn') || '+ Añadir 2ª unidad';
    var defColor = drawer.getAttribute('data-color-default') || '';
    var busy = false;
    function money(c) { return '€' + (c / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }

    // ---- Aviso compacto arriba a la derecha al añadir al carrito ----
    var note = document.querySelector('[data-cart-note]');
    var noteItem = note && note.querySelector('[data-cartnote-item]');
    var noteCartBtn = note && note.querySelector('[data-cartnote-cart]');
    var noteTimer = null;
    function noteHide() { if (!note) return; note.classList.remove('mt-open'); clearTimeout(noteTimer); noteTimer = setTimeout(function () { note.hidden = true; }, 350); }
    function noteShow(cart, added) {
      if (!note) return;
      clearTimeout(noteTimer);
      var it = (added && added.id) ? added : (added && added.items && added.items[0]) || (cart.items && cart.items[0]);
      if (noteItem && it) {
        var img = it.image || (it.featured_image && it.featured_image.url) || '';
        var vt = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
        noteItem.innerHTML = (img ? '<img src="' + img + '" alt="">' : '') +
          '<div class="mt-cartnote__info"><span class="mt-cartnote__title">' + esc(it.product_title || it.title) + '</span>' +
          (vt ? '<span class="mt-cartnote__meta">Pack: ' + esc(vt) + '</span>' : '') + '</div>';
      }
      if (noteCartBtn) noteCartBtn.textContent = 'Ver carrito (' + cart.item_count + ')';
      note.hidden = false;
      requestAnimationFrame(function () { note.classList.add('mt-open'); });
    }
    if (note) note.querySelectorAll('[data-cartnote-close]').forEach(function (b) { b.addEventListener('click', noteHide); });
    function open() { drawer.hidden = false; requestAnimationFrame(function () { drawer.classList.add('mt-open'); }); document.documentElement.classList.add('mt-drawer-lock'); }
    function close() { drawer.classList.remove('mt-open'); document.documentElement.classList.remove('mt-drawer-lock'); setTimeout(function () { drawer.hidden = true; }, 350); }
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', function (e) { if (b.tagName !== 'A') e.preventDefault(); close(); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });
    function giftState(cart) {
      var hasGift = false, hasOne = false, names = '';
      cart.items.forEach(function (it) {
        var q = parseInt(it.variant_title || '', 10);
        var prop = it.properties && it.properties['🎁 Regalos incluidos'];
        if (prop || q >= 2) hasGift = true;
        if (prop && prop.length > names.length) names = prop.replace(/\s*\(GRATIS\)\s*$/, '');
        if (q === 1) hasOne = true;
      });
      return { hasGift: hasGift, hasOne: hasOne, names: names };
    }
    function render(cart) {
      countEl.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
      if (!cart.items.length) { itemsEl.innerHTML = ''; emptyEl.hidden = false; footEl.hidden = true; giftEl.hidden = true; upsellEl.hidden = true; return; }
      emptyEl.hidden = true; footEl.hidden = false;
      var html = '';
      cart.items.forEach(function (it) {
        var gift = it.properties && it.properties['🎁 Regalos incluidos'];
        var colors = [];
        if (it.properties) Object.keys(it.properties).forEach(function (k) { if (/^Color/.test(k)) colors.push(it.properties[k]); });
        html += '<div class="mt-ditem" data-key="' + esc(it.key) + '">'
          + '<a class="mt-ditem__img" href="' + esc(it.url) + '"' + (it.image ? ' style="background-image:url(\'' + esc(it.image) + '\')"' : '') + '></a>'
          + '<div class="mt-ditem__info">'
          + '<a class="mt-ditem__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>'
          + (it.variant_title && it.variant_title !== 'Default Title' ? '<span class="mt-ditem__opt">' + esc(it.variant_title) + '</span>' : '')
          + (colors.length ? '<span class="mt-ditem__opt">Color: ' + esc(colors.join(', ')) + '</span>' : '')
          + (gift ? '<span class="mt-ditem__gift">🎁 ' + esc(gift) + '</span>' : '')
          + '<div class="mt-ditem__row">'
          + '<div class="mt-qty"><button type="button" class="mt-qty__b" data-dq-minus aria-label="Quitar uno">−</button><span class="mt-qty__n">' + it.quantity + '</span><button type="button" class="mt-qty__b" data-dq-plus aria-label="Añadir uno">+</button></div>'
          + '<span class="mt-ditem__price">' + money(it.final_line_price) + '</span>'
          + '</div>'
          + '<button type="button" class="mt-ditem__rm" data-dq-remove>Quitar</button>'
          + '</div></div>';
      });
      itemsEl.innerHTML = html;
      subEl.textContent = money(cart.items_subtotal_price);
      var g = giftState(cart);
      giftEl.hidden = !giftsOn;
      upsellEl.hidden = true;
      if (g.hasGift) {
        giftEl.classList.add('mt-done');
        giftTxt.innerHTML = '🎉 <b>¡Has desbloqueado tus regalos GRATIS!</b> ' + esc(g.names || giftNames);
        giftFill.style.width = '100%';
      } else if (g.hasOne) {
        giftEl.classList.remove('mt-done');
        giftTxt.innerHTML = '🎁 Estás a <b>1 unidad</b> de desbloquear tus <b>regalos GRATIS</b>';
        giftFill.style.width = '55%';
        // upsellTxt viene del ajuste del tema (admite <b>), escapado por Liquid al pintarlo en el atributo
        if (v2 && upsellTxt) { upsellEl.hidden = false; upsellEl.innerHTML = '<div class="mt-dupsell__txt">' + upsellTxt + '</div><button type="button" class="mt-dupsell__btn" data-dq-upsell>' + esc(upsellBtn) + '</button>'; }
      } else { giftEl.hidden = true; }
    }
    function updateBubble(cart) { var b = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden]'); if (b) b.textContent = cart.item_count; }
    function fetchCart(cb) { fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { render(c); if (cb) cb(c); }); }
    function change(key, qty) {
      if (busy) return; busy = true; panel.classList.add('mt-loading');
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json(); }).then(function (c) { render(c); updateBubble(c); }).catch(function () {}).then(function () { busy = false; panel.classList.remove('mt-loading'); });
    }
    itemsEl.addEventListener('click', function (e) {
      var item = e.target.closest('.mt-ditem'); if (!item) return;
      var key = item.getAttribute('data-key');
      var n = parseInt(item.querySelector('.mt-qty__n').textContent, 10) || 1;
      if (e.target.closest('[data-dq-plus]')) change(key, n + 1);
      else if (e.target.closest('[data-dq-minus]')) change(key, n - 1);
      else if (e.target.closest('[data-dq-remove]')) change(key, 0);
    });
    upsellEl.addEventListener('click', function (e) {
      if (!e.target.closest('[data-dq-upsell]') || busy) return;
      busy = true; panel.classList.add('mt-loading');
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var oneLine = null;
        cart.items.forEach(function (it) { if (String(it.variant_id) === String(v1)) oneLine = it; });
        var props = {};
        if (defColor) { props['Color (unidad 1)'] = defColor; props['Color (unidad 2)'] = defColor; }
        if (oneLine && oneLine.properties && oneLine.properties['Color (unidad 1)']) props['Color (unidad 1)'] = oneLine.properties['Color (unidad 1)'];
        if (giftsOn && giftNames) props['🎁 Regalos incluidos'] = giftNames + ' (GRATIS)';
        var body = { items: [{ id: parseInt(v2, 10), quantity: 1, properties: props }] };
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }).then(function () {
          if (oneLine) return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: oneLine.key, quantity: 0 }) });
        });
      }).then(function () { fetchCart(updateBubble); }).catch(function () {}).then(function () { busy = false; panel.classList.remove('mt-loading'); });
    });
    var couponForm = drawer.querySelector('[data-drawer-coupon]');
    if (couponForm) couponForm.addEventListener('submit', function (e) { e.preventDefault(); var code = couponForm.querySelector('input[name="code"]').value.trim(); if (code) window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout'; });
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.getAttribute || form.getAttribute('action') == null) return;
      if (form.getAttribute('action').indexOf('/cart/add') === -1) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var fd = new FormData(form);
      if (btn) { btn.classList.add('mt-btn--loading'); btn.disabled = true; }
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function (added) { fetchCart(function (c) { updateBubble(c); noteShow(c, added); }); if (btn) { var orig = btn.getAttribute('data-label-add') || btn.textContent; btn.classList.remove('mt-btn--loading'); btn.classList.add('mt-btn--done'); btn.textContent = '✓ ¡Añadido!'; setTimeout(function () { btn.classList.remove('mt-btn--done'); btn.textContent = orig; btn.disabled = false; }, 1600); } })
        .catch(function () { if (btn) { btn.classList.remove('mt-btn--loading'); btn.disabled = false; } form.submit(); });
    });
    // El icono de la cesta navega directo a /cart (sin abrir el drawer lateral).
    fetchCart();
  }

  function boot() {
    if (window.__mtBooted) return;
    window.__mtBooted = true;
    initReveals();
    initCountUp();
    initFaq();
    initGallery();
    initCoverflow();
    initHumo();
    initVariants();
    initPackColors();
    initGifts();
    initReels();
    initStickyBar();
    initHero3D();
    initTilt();
    initLiveCount();
    initCountdown();
    initUpsell();
    initRutina();
    initCartPopup();
    initVideoSound();
    initWelcome();
    initSalePops();
    initAntesDespues();
    initDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
